import { useGoogleReviews } from '@/src/data/google-reviews/useGoogleReviews';
import Image from '@/src/shared/components/Image';
import Rate from '@/src/shared/components/Antd/Rate';
import { Typography } from '@/src/shared/components/Typography';

import styles from './GoogleReviews.module.scss';
import clsx from 'clsx';
import Link from 'next/link';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';

interface Props {
  className?: string;
}

export const GoogleReviews = ({ className }: Props) => {
  const isMobile = useIsMobile();
  const { data: googleReview } = useGoogleReviews();

  const { rating, user_ratings_total: totalReviews } =
    googleReview?.result || {};

  return (
    <Link href="https://maps.app.goo.gl/E1ChdJhNMyXAzKeh9" target="_blank">
      <div className={clsx(styles.container, className)}>
        <Image
          src="/images/google/google-logo.png"
          alt="google-logo"
          width={isMobile ? 50 : 100}
          height={isMobile ? 50 : 100}
        />

        <div className={styles.mainWrapper}>
          <div className={styles.result}>
            <Typography
              tag="span"
              variant="text"
              size={isMobile ? 'sm' : 'xl'}
              fontWeight="bold"
              className={styles.rating}
            >
              {rating}
            </Typography>
            <Rate value={rating} allowHalf disabled className={styles.stars} />
          </div>

          <Typography
            tag="span"
            variant="text"
            size={isMobile ? 'xs' : 'md'}
            fontWeight="regular"
          >
            {totalReviews?.toLocaleString()} Trusted Users
          </Typography>
        </div>
      </div>
    </Link>
  );
};
